import { render } from "./CipherbcAddress.vue?vue&type=template&id=668fc531&scoped=true"
import script from "./CipherbcAddress.vue?vue&type=script&lang=js"
export * from "./CipherbcAddress.vue?vue&type=script&lang=js"

import "./CipherbcAddress.vue?vue&type=style&index=0&id=668fc531&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668fc531"]])

export default __exports__